
<div *ngIf="calendarInitialized">

	<full-calendar  [options]="calendarOptions"></full-calendar>

</div>
